import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Container, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import './Login.css';
import logo from './assets/Logo.png';

function Login() {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [serviceModal, setServiceModal] = useState(false);
  const navigate = useNavigate();
const params = new URLSearchParams(window.location.search);
const redirectPath = params.get("redirect") || "/customer-dashboard";


  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleInputChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    if (!credentials.email || !credentials.password) {
      setError("❌ Please enter both email and password.");
      return;
    }
    try {
      const response = await fetch("https://carcure.ca/backend/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message);
      localStorage.setItem("userToken", data.token);
      localStorage.setItem("userData", JSON.stringify(data.user));

      if (data.user.role === "admin") {
        navigate('/admin-dashboard');
      } else {
        if (data.user.serviceAvailability && data.user.serviceAvailability === "NA") {
          setServiceModal(true);
        } else {
          navigate(redirectPath); 
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleCloseModal = () => {
    navigate('/');
  };

  const handleEditProfile = () => {
    navigate('/edit-profile');
  };

  const handleClose = () => {
    navigate('/');
  };

  if (serviceModal) {
    return (
      <Dialog open={serviceModal} onClose={handleCloseModal}>
        <DialogTitle>Service Unavailable</DialogTitle>
        <DialogContent>
          <Typography>
            Thank you for logging in. Unfortunately, the service is not available in your area at this time. We will notify you as soon as the service is launched in your region.
            <br /><br />
            Would you like to update your profile?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} className="dialog-close-button">Close</Button>
          <Button onClick={handleEditProfile} className="dialog-edit-button">Edit Profile</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div className="login-page-wrapper">
      <div className="content-container">
        <div className="top-text-box">
          <Typography variant="h4" className="top-box">
            🚗 We keep your car road-ready at all times
          </Typography>
        </div>

        <div className="login-container">
          <button className="close-button" onClick={handleClose}>×</button>
          <div className="logo-container">
            <img src={logo} alt="Logo" className="login-logo" />
          </div>
          <Container maxWidth="sm" sx={{ mt: -1 }}>
            {error && (
              <Typography color="error" style={{ textAlign: 'center', marginBottom: '10px' }}>
                {error}
              </Typography>
            )}
            <TextField 
              className="custom-input"
              fullWidth 
              label="Email" 
              name="email" 
              value={credentials.email} 
              onChange={handleInputChange} 
              margin="normal" 
              type="email" 
              autoComplete="off" 
            />
            <TextField 
              className="custom-input"
              fullWidth 
              label="Password" 
              name="password" 
              value={credentials.password} 
              onChange={handleInputChange} 
              margin="normal" 
              type="password" 
              autoComplete="new-password" 
            />
            <Button 
              variant="contained"
              fullWidth
              onClick={handleLogin}
              className="custom-button"
            >
              Login
            </Button>
            <Button 
              variant="outlined" 
              color="secondary" 
              fullWidth
              onClick={() => navigate('/forget-password')}
              style={{ marginTop: '10px' }}
            >
              Forgot Password
            </Button>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default Login;
